import { Component, Model, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import { VBtn, VIcon, VSpacer, VToolbar, VToolbarTitle } from 'vuetify/lib'

@Component
export class AppDialogToolbar extends Vue {
	@Prop({ type: String, required: true }) title!: string
	@Prop({ type: String, required: false, default: 'primary' }) color!: string
	@Model('input', { type: Boolean, required: false }) value!: boolean

	render() {
		return (
			<VToolbar dense color={this.color} dark elevation="0">
				<VToolbarTitle>
					<span class="font-weight-medium ml-3">{this.title}</span>
				</VToolbarTitle>
				<VSpacer />
				<VBtn icon onclick={() => this.closeDialog()}>
					<VIcon>close</VIcon>
				</VBtn>
			</VToolbar>
		)
	}

	/**
	 * Emite para o VModel false para fechar o dialogo
	 */
	closeDialog() {
		this.$emit('dialog:close', false)
		this.$emit('input', false)
	}
}
